import { ChevronLeft, ChevronRight } from "lucide-react";


const Pagination = ({
  currentPage,
  totalPages,
  setCurrentPage,
}) => {


  return (

    <div className="
      flex
      justify-center
      items-center
      gap-3
      mt-12
    ">


      {/* Previous */}

      <button
        disabled={currentPage === 1}
        onClick={() =>
          setCurrentPage(currentPage - 1)
        }
        className="
          w-10
          h-10
          rounded-full
          border
          flex
          items-center
          justify-center
          hover:border-green-600
          hover:text-green-600
          disabled:opacity-40
        "
      >
        <ChevronLeft size={18}/>
      </button>



      {/* Pages */}

      {[...Array(totalPages)].map((_,index)=>{

        const page = index + 1;


        return (

          <button

            key={page}

            onClick={() =>
              setCurrentPage(page)
            }

            className={`
              w-10
              h-10
              rounded-full
              transition

              ${
                currentPage === page
                ?
                "bg-green-600 text-white"
                :
                "border hover:border-green-600 hover:text-green-600"
              }
            `}
          >
            {page}
          </button>

        );

      })}



      {/* Next */}

      <button
        disabled={currentPage === totalPages}
        onClick={() =>
          setCurrentPage(currentPage + 1)
        }
        className="
          w-10
          h-10
          rounded-full
          border
          flex
          items-center
          justify-center
          hover:border-green-600
          hover:text-green-600
          disabled:opacity-40
        "
      >

        <ChevronRight size={18}/>

      </button>


    </div>

  );

};


export default Pagination;